/**
 * Every masterclass and lesson by key, for the reader (content/ContentPage.jsx)
 * and for BAM IQ, which reads a module's own words when a coach attaches it to
 * a conversation (api/_bamiq/attach.js). Plain data: no React, so the server
 * can import it.
 */
import { AAU_MODULE, AAU_MODULE_KEY } from "./aauModule.js";
import { RIKKI_MODULE, RIKKI_MODULE_KEY } from "./rikkiModule.js";
import { NBA_PLAYER_DEV_MODULE, NBA_PLAYER_DEV_KEY } from "./nbaPlayerDevModule.js";
import { NBA_CLA_LAYERS_MODULE, NBA_CLA_LAYERS_KEY } from "./nbaClaLayersModule.js";
import { SIMPLIFYING_SCIENCE_MODULE, SIMPLIFYING_SCIENCE_MODULE_KEY } from "./simplifyingScienceModule.js";
import { TRUTHS_OF_COACHING_MODULE, TRUTHS_OF_COACHING_MODULE_KEY } from "./truthsOfCoachingModule.js";
import { POINT_GUARD_MASTERCLASS, POINT_GUARD_MASTERCLASS_KEY } from "./pointGuardModule.js";
import { SCIENCE_IN_PRACTICE_MODULE, SCIENCE_IN_PRACTICE_MODULE_KEY } from "./scienceInPracticeModule.js";
import { SHOOTING_CLINIC_MODULE, SHOOTING_CLINIC_MODULE_KEY } from "./shootingClinicModule.js";
import { WARMUP_MODULE, WARMUP_MODULE_KEY } from "./warmupModule.js";
import { MOTOR_LEARNING_MODULE, MOTOR_LEARNING_MODULE_KEY } from "./motorLearningModule.js";
import { SKILL_ACQUISITION_SHOOTING_MODULE, SKILL_ACQUISITION_SHOOTING_MODULE_KEY } from "./skillAcquisitionShootingModule.js";
import { GAMES_APPROACH_MODULE, GAMES_APPROACH_MODULE_KEY } from "./gamesApproachModule.js";
import { BUILDING_MOVERS_MODULE, BUILDING_MOVERS_MODULE_KEY } from "./buildingMoversModule.js";
import { FOUNDATIONAL_CONCEPTS_MODULE, FOUNDATIONAL_CONCEPTS_MODULE_KEY } from "./foundationalConceptsModule.js";
import { IMPORTANT_DEFINITIONS_1_MODULE, IMPORTANT_DEFINITIONS_1_MODULE_KEY } from "./importantDefinitions1Module.js";
import { IMPORTANT_DEFINITIONS_2_MODULE, IMPORTANT_DEFINITIONS_2_MODULE_KEY } from "./importantDefinitions2Module.js";
import { RESEARCH_1V1_SHOOTING_MODULE, RESEARCH_1V1_SHOOTING_MODULE_KEY } from "./research1v1ShootingModule.js";
import { INTERNAL_EXTERNAL_CUES_MODULE, INTERNAL_EXTERNAL_CUES_MODULE_KEY } from "./internalExternalCuesModule.js";
import { DIFFERENTIAL_LEARNING_MODULE, DIFFERENTIAL_LEARNING_MODULE_KEY } from "./differentialLearningModule.js";
import { PSYCHOLOGICAL_SKILLS_MODULE, PSYCHOLOGICAL_SKILLS_MODULE_KEY } from "./psychologicalSkillsModule.js";
import { BALANCE_SHOOTING_MODULE, BALANCE_SHOOTING_MODULE_KEY } from "./balanceShootingModule.js";
import { LET_THE_TASK_TEACH_MODULE, LET_THE_TASK_TEACH_MODULE_KEY } from "./letTheTaskTeachModule.js";
import { PASSING_MODULE, PASSING_MODULE_KEY } from "./passingModule.js";
import { TWO_FEET_MODULE, TWO_FEET_MODULE_KEY } from "./twoFeetModule.js";
import { PASSING_ACCURACY_MODULE, PASSING_ACCURACY_MODULE_KEY } from "./passingAccuracyModule.js";
import { LESSON_MODULES } from "../lessons/index.js";

export const MASTERCLASS_MODULES = {
  [AAU_MODULE_KEY]: AAU_MODULE,
  [RIKKI_MODULE_KEY]: RIKKI_MODULE,
  [NBA_PLAYER_DEV_KEY]: NBA_PLAYER_DEV_MODULE,
  [NBA_CLA_LAYERS_KEY]: NBA_CLA_LAYERS_MODULE,
  [SIMPLIFYING_SCIENCE_MODULE_KEY]: SIMPLIFYING_SCIENCE_MODULE,
  [TRUTHS_OF_COACHING_MODULE_KEY]: TRUTHS_OF_COACHING_MODULE,
  [POINT_GUARD_MASTERCLASS_KEY]: POINT_GUARD_MASTERCLASS,
  [SCIENCE_IN_PRACTICE_MODULE_KEY]: SCIENCE_IN_PRACTICE_MODULE,
  [SHOOTING_CLINIC_MODULE_KEY]: SHOOTING_CLINIC_MODULE,
  [WARMUP_MODULE_KEY]: WARMUP_MODULE,
  [MOTOR_LEARNING_MODULE_KEY]: MOTOR_LEARNING_MODULE,
  [SKILL_ACQUISITION_SHOOTING_MODULE_KEY]: SKILL_ACQUISITION_SHOOTING_MODULE,
  [GAMES_APPROACH_MODULE_KEY]: GAMES_APPROACH_MODULE,
  [BUILDING_MOVERS_MODULE_KEY]: BUILDING_MOVERS_MODULE,
  [FOUNDATIONAL_CONCEPTS_MODULE_KEY]: FOUNDATIONAL_CONCEPTS_MODULE,
  [IMPORTANT_DEFINITIONS_1_MODULE_KEY]: IMPORTANT_DEFINITIONS_1_MODULE,
  [IMPORTANT_DEFINITIONS_2_MODULE_KEY]: IMPORTANT_DEFINITIONS_2_MODULE,
  [RESEARCH_1V1_SHOOTING_MODULE_KEY]: RESEARCH_1V1_SHOOTING_MODULE,
  [INTERNAL_EXTERNAL_CUES_MODULE_KEY]: INTERNAL_EXTERNAL_CUES_MODULE,
  [DIFFERENTIAL_LEARNING_MODULE_KEY]: DIFFERENTIAL_LEARNING_MODULE,
  [PSYCHOLOGICAL_SKILLS_MODULE_KEY]: PSYCHOLOGICAL_SKILLS_MODULE,
  [BALANCE_SHOOTING_MODULE_KEY]: BALANCE_SHOOTING_MODULE,
  [LET_THE_TASK_TEACH_MODULE_KEY]: LET_THE_TASK_TEACH_MODULE,
  [PASSING_MODULE_KEY]: PASSING_MODULE,
  [TWO_FEET_MODULE_KEY]: TWO_FEET_MODULE,
  [PASSING_ACCURACY_MODULE_KEY]: PASSING_ACCURACY_MODULE,
  // Lessons share the masterclass reader. Same module shape, smaller
  // scope. Registered in the same map so the existing openModule path
  // resolves them without a second reader code path.
  ...LESSON_MODULES,
};
